// 이미지 짱많, 유튜브 영상
// 푸터 위에contact 구역 있음, 오른쪽에 contact 픽스 있음,
// 하단에 form 픽스, 신청하기 , 푸터
// formFieldColor="white" (이름&번호 input 배경 흰색)
// 질문 2개 - 이름 & 번호, 치료종류(select)
// 특이사항 - form 하단에 픽스스

import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  dentalOptions,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import PrivacyContent from "./PrivacyContent";

function RandingStyle22({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img7Path,
  img8Path,
  img9Path,
  videoThumbnail,
  videoUrl,
  fixedDbImgPath,
  formFieldColor,
  privacyMessage,
  keepBTN,
  postBTN,
  companyName,
  privacyCompanyName,
  isCallInsideContactBox,
  isKakaoInsideContactBox,
  isFixedCallIcon,
  isFixedKakaoIcon,
  fixedDbColor,
  callNumber,
  kakaoLink,
  footerPath,
  benefitInfo = true,
  // 랜딩 별로 태그 설정인 경우
  apiUrl,
  treatments,
  adTarget,
  redirectUrl,
  kakaotalk,
  carrotTag,
  btnSize22, // 버튼 사이즈 작은거
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (event) => {
    const newOption = event.target.value;
    setSelectedOption(newOption); // 상태 업데이트

    // 상태 업데이트 후 바로 새로운 값을 확인하려면 이곳에서 처리
    console.log(newOption); // 바로 선택된 값을 찍을 수 있음
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    // selectedValue가 빈 값일 경우 treatments의 첫 번째 value로 설정
    const finalSelectedValue =
      selectedValue && selectedValue !== ""
        ? selectedValue
        : treatments && treatments.length > 0
        ? treatments[0].value
        : null; // treatments가 비어 있는 경우 null

    if (treatments && !finalSelectedValue) {
      console.error("선택 가능한 값이 없습니다.");
      return; // treatments가 비어 있는 경우 처리
    }

    console.log(treatments);
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      selectedValue: finalSelectedValue, // 업데이트된 selectedValue 전달
      redirectUrl,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      <div className="step2">
        {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
        {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}

        {videoUrl && (
          <div className="video-div">
            <iframe
              className="video-frame"
              src={`${videoUrl}`}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        )}

        {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
        {img6Path && <img src={img6Path} alt="임플란트 고민중이세요?" />}
        {img7Path && <img src={img7Path} alt="임플란트 고민중이세요?" />}
        {img8Path && <img src={img8Path} alt="임플란트 고민중이세요?" />}
        {img9Path && <img src={img9Path} alt="임플란트 고민중이세요?" />}

        <div className="contactBox">
          {/* 전화번호 아이콘 */}
          {isCallInsideContactBox && (
            <div className="contact">
              <a href={callNumber}>
                <img
                  src={`${process.env.REACT_APP_CDN_BASE}/images/031/callFront.png`}
                  alt="Call 1577-7371"
                />
              </a>
              <img
                src={`${process.env.REACT_APP_CDN_BASE}/images/031/callBack.jpg`}
                alt=""
              />
            </div>
          )}

          {isKakaoInsideContactBox && (
            <div className="contact">
              {/* 카카오톡 아이콘 */}
              <a href={kakaoLink} target="_blank" rel="noopener noreferrer">
                <img
                  src={`${process.env.REACT_APP_CDN_BASE}/images/031/kakaoFront.png`}
                  alt="Kakao Link"
                />
              </a>
              <img
                src={`${process.env.REACT_APP_CDN_BASE}/images/031/kakaoBack.jpg`}
                alt=""
              />
            </div>
          )}
        </div>
        <div className="qBox fixed4" style={{ backgroundColor: fixedDbColor }}>
          {fixedDbImgPath && (
            <img
              style={{ marginBottom: "2%" }}
              className="fixedDbImgPath"
              src={fixedDbImgPath}
              alt=""
            />
          )}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div
              style={{
                width: btnSize22 ? "75%" : treatments && "49.5%",
              }}
              className={`formField ${
                formFieldColor ? formFieldColor : "white"
              }`}
            >
              {treatments ? "" : <label htmlFor="name">이름</label>}

              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={treatments ? "성함" : "성함을 입력해주세요."}
                className="nameInput"
              />
            </div>
            {treatments && (
              <SelectEvents
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                treatments={treatments}
                propswidth={treatments && "49.5%"}
                formFieldColor={formFieldColor}
              />
            )}
            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
              formFieldColor={formFieldColor}
              treatments={treatments}
              btnSize22={btnSize22}
            />
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={privacyName} />
                </div>
              </div>
            )}
            {benefitInfo && (
              <p className="benefitInfo">
                <BenefitPeriod />
                <br />
                이벤트 대상자 : {adTarget || "해당 매체 이용자"}
              </p>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
              style={btnSize22 ? { width: "22%" } : undefined}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
      </div>
      <div className="fixedContactIcons">
        {/* 전화번호 아이콘 */}
        {isFixedCallIcon && (
          <a href={callNumber}>
            <img
              src={`${process.env.REACT_APP_CDN_BASE}/images/031/callIcon.png`}
              alt="Call 1577-7371"
            />
          </a>
        )}

        {/* 카카오톡 아이콘 */}
        {isFixedKakaoIcon && (
          <a href={kakaoLink} target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.REACT_APP_CDN_BASE}/images/031/kakaoIcon.png`}
              alt="Kakao Link"
            />
          </a>
        )}
      </div>
      {footerPath && (
        <div className="footer">
          {footerPath && <img src={footerPath} alt="푸터" />}{" "}
        </div>
      )}
    </div>
  );
}

export default RandingStyle22;
